<div class="mt-3">
  @if ((topics$ | async); as topics) {
    <div class="flex flex-column gap-3">
      @for (topic of topics; track topic.heading) {
        <div class="flex align-items-center">
          <p-checkbox name="topics"
                      [value]="topic.heading"
                      [(ngModel)]="selectedTopicHeadings"
                      [inputId]="'topic-' + topic.order">
          </p-checkbox>
          <label [for]="'topic-' + topic.order"
                 class="ml-2">{{ topic.heading }}</label>
        </div>
      }
    </div>
  }
</div>

<div class="flex align-items-center justify-content-center w-full mt-5">
  <p-button (onClick)="save()"
            [disabled]="requestInProcess"
            label="Save"
            i18n-label>
  </p-button>
</div>